import { Range, Editor, Text } from 'slate';
import { serializeToHTML } from '../../serialization/serialize/html/serializeToHTML.mjs';
import { deserializeHTML } from '../../serialization/deserialize/html/deserializeHTML.mjs';
import { isInline } from '../../queries/isInline.mjs';
import { isVoidNode } from '../../queries/isVoidNode.mjs';

var Header = /*#__PURE__*/function (Header) {
  Header["Html"] = "text/html";
  Header["PlainText"] = "text/plain";
  return Header;
}(Header || {});
/**
 * Set Slate fragment as serialized HTML / plain text on the clipboard
 */
function setFragmentData(data, {
  editor,
  plugins
}) {
  const {
    selection
  } = editor;
  if (!selection) {
    return;
  }
  const [start] = Range.edges(selection);
  const startVoid = Editor.void(editor, {
    at: start.path
  });
  if (Range.isCollapsed(selection) && !startVoid) {
    return;
  }
  const fragment = editor.getFragment();
  const serialized = serializeToHTML(fragment, {
    plugins
  });
  data.setData(Header.Html, serialized);
  data.setData(Header.PlainText, isPlainTextFragment(editor, fragment) ? serialized : safelyExtractTextContent(serialized));
}

/**
 * Deserialize clipboard data into a Slate fragment that can be inserted into the editor
 */
function extractFragmentData(data, {
  editor,
  plugins
}) {
  const value = data.getData(Header.Html) || data.getData(Header.PlainText);
  if (value) {
    return deserializeHTML(value, {
      editor,
      plugins
    });
  }
  return null;
}
function safelyExtractTextContent(html) {
  var _body$textContent;
  // Using `DOMParser` rather than setting `innerHTML` to prevent potential XSS
  const {
    body
  } = new DOMParser().parseFromString(html, 'text/html');
  return (_body$textContent = body.textContent) != null ? _body$textContent : '';
}
function isPlainTextFragment(editor, fragment) {
  const documentFragment = fragment[0];
  if (Text.isText(documentFragment)) {
    return true;
  }
  return documentFragment.children.every(isPlainText);
  function isPlainText(node) {
    return Text.isText(node) ||
    // TO-DO: This is a bit arbitrary and coupled to our use-case, find a better strategy
    isInline(editor, node) && isVoidNode(editor, node);
  }
}

export { extractFragmentData, setFragmentData };
